import React, { Component } from 'react';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonUsualText from '../../../common-components/common-usual-text';

class Description extends Component {
    render() {
        return (
            <div className="description">
                <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                    <CommonTitle className="description__title">Описание проекта</CommonTitle>
                </ScrollAnimation>

                <div className="description__wrapper">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="description__text-wrapper"
                    >
                        <CommonUsualText className="description__text">
                            С&nbsp;компанией BONUM агентство &laquo;Вебпрактик&raquo; сотрудничает
                            с&nbsp;2017 года по&nbsp;различным направлениям интернет-маркетинга.
                            В&nbsp;2021 году из-за смены общей экономической ситуации в&nbsp;связи
                            с&nbsp;пандемией мы&nbsp;поменяли рекламную стратегию. При этом
                            неизменной остается цель&nbsp;- рост клиентских заявок на&nbsp;покупку
                            спецтехники, снижение стоимости качественных лидов и&nbsp;увеличение
                            конверсии.
                        </CommonUsualText>

                        <CommonUsualText className="description__text">
                            Мы&nbsp;предложили реализовать эту стратегию за&nbsp;счет тестирования
                            различных гипотез, каналов продвижения и&nbsp;новых креативных
                            концепций.
                        </CommonUsualText>

                        <CommonUsualText className="description__text">
                            BONUM&nbsp;&mdash; крупный современный машиностроительный завод,
                            с&nbsp;2014 года работает на&nbsp;рынке России и&nbsp;в&nbsp;странах
                            СНГ, продажи ведутся через отдел продаж и&nbsp;многостраничный сайт
                            с&nbsp;каталогом.
                        </CommonUsualText>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="zoomIn"
                        offset={0}
                        animateOnce={true}
                        duration={1.2}
                        className="description__img-wrapper"
                    >
                        <img
                            className="description__img"
                            src="/images/pic/bonum/description-img.png"
                            alt="truck"
                            loading="lazy"
                        />
                        <img
                            className="description__img description__img--mobile"
                            src="/images/pic/bonum/description-img-mobile.png"
                            alt="truck"
                            loading="lazy"
                        />
                    </ScrollAnimation>
                </div>
            </div>
        );
    }
}

export default Description;
